import Navbar from '../externals/Navbar';
import Hero from '../externals/Hero';
import Footer from '../externals/Footer';
import { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Worker, Viewer } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import { useNavigate } from 'react-router';

function Results26(){

  const navigate = useNavigate();
  function showRequestedResults(event){

    switch(event.target.id)
    {
        case "EtapaI":
            window.open(require("../../docs/CN_2026_Etapa_I_Results.pdf"));
            break;
        
        case "EtapaII":
            window.open(require("../../docs/CN_2026_Etapa_II_Results.pdf"));
            break;

        case "EtapaIII":
            window.open(require("../../docs/CN_2026_Etapa_III_Results.pdf"));
            break;
        
        case "EtapaIV":
            window.open(require("../../docs/CN_2026_Etapa_IV_Results.pdf"));
            break;
      
        case "EtapaV":
            window.open(require("../../docs/CN_2026_Etapa_V_Results.pdf"));
            break;

        case "EtapaVTeams":
            alert("Nu sunt rezultate disponibile momentan!");
            break;
            
        case "EtapaVI":
            window.open(require("../../docs/CN_2026_Etapa_VI_Results.pdf"));
            break;

        case "EtapaVII":
            window.open(require("../../docs/CN_2026_Etapa_VII_Results.pdf"));
            break;

        case "FanArm":
            window.open(require("../../docs/FanArm_Cup_2026_Results.pdf"));
            break;

        case "EtapaVIII":
            window.open(require("../../docs/CN_2026_Etapa_VIII_Results.pdf"));
            break;

        case "EtapaIX":
            window.open(require("../../docs/CN_2026_Etapa_IX_Results.pdf"));
            break;

        case "EtapaX":
            window.open(require("../../docs/CN_2026_Etapa_X_Results.pdf"));
            break;
            
        case "EtapaXI":
            alert("Nu sunt rezultate disponibile momentan!");
            break;  

        case "EtapaXII":
            alert("Nu sunt rezultate disponibile momentan!");
            break; 

        case "Overall":
            window.location.href = 'https://nodeppcbackend-production.up.railway.app/api/finalStats';
        default:
            break;
    }

}

function showLiveResults()
{
navigate('/Live');
}

function goToResultSearch()
{
    navigate('/Search Results');
}

  return(
    <div> 
        <Navbar />
        <Hero />
        <br></br>
        <br></br> 
            <div className='container text-center'>
            <div className="card shadow-lg text-left">
                      <div className="card-body">
                          
                            <br></br>
                            <br></br>
                            <button className='btn btn-light' id='EtapaI' onClick={showRequestedResults}>Etapa I - Timisoara - 29 Ianuarie - 1 Februarie</button>
                            <br></br>
                            <br></br>
                            <button className='btn btn-light' id='EtapaII' onClick={showRequestedResults}>Etapa II - Cluj-Napoca - 19, 20, 21 Februarie</button>
                            <br></br>
                            <br></br>
                            <button className='btn btn-light' id='EtapaIII' onClick={showRequestedResults}>Etapa III - Timsioara - 26, 27, 28 Martie</button>
                            <br></br>
                            <br></br>
                            <button className='btn btn-light' id='EtapaIV' onClick={showRequestedResults}>Etapa IV - Joita - 23, 24, 25 Aprilie</button>
                            <br></br>
                            <br></br>
                            <button className='btn btn-light' id='EtapaV' onClick={showRequestedResults}>Etapa V  - Joita - 21, 22, 23 Mai</button>
                            <br></br>
                            <br></br>                            
                            <button className='btn btn-light' id='EtapaVI' onClick={showRequestedResults}>Etapa VI - Bistrita - 18, 19, 20 Iunie</button>
                            <br></br>
                            <br></br>
                            <button className='btn btn-light' id='EtapaVII' onClick={showRequestedResults}>Etapa VII - Joita - 23, 24, 25 Iulie</button>
                            <br></br>
                            <br></br>
                            <button className='btn btn-light' id='FanArm' onClick={showRequestedResults}>Cupa FanArm - Reghin - 14, 15 August</button>
                            <br></br>
                            <br></br>
                            <button className='btn btn-light' id='EtapaVIII' onClick={showRequestedResults}>Etapa VIII - Joita - 27, 28, 29 August</button>
                            <br></br>
                            <br></br>
                            <button className='btn btn-light' id='EtapaIX' onClick={showRequestedResults}>Etapa IX - Timisoara - 11, 12, 13 Septembrie</button>
                            <br></br>
                            <br></br>
                            <button className='btn btn-light' id='EtapaX' onClick={showRequestedResults}>Etapa X Finala - Joita - 8, 9, 10 Octombrie</button>
                            <br></br>
                            <br></br>
                            <button className='btn btn-light' id='EtapaXI' onClick={showRequestedResults}>Cupa Romaniei - Cluj-Napoca - 19, 20, 21 Noiembrie</button>
                            <br></br>
                            <br></br>
                            <button className='btn btn-light' id='EtapaXII' onClick={showRequestedResults}>Cupa De Iarna - Bucuresti - 3, 4, 5 Decembrie</button>
                            <br></br>
                            <br></br>
                            <button className='btn btn-light' id='Overall' onClick={showRequestedResults}>Overall</button>
                            <br></br>
                            <br></br>
                            <button className='btn btn-warning' id='live' onClick={showLiveResults}>Rezultate Live</button>
                            <br></br>
                            <br></br>
                            <button className='btn btn-warning' id='searchresults' onClick={goToResultSearch}>Cauta rezultate</button>
                            <br></br>
                            <br></br>
                           
                           
                      </div>
              </div>
            </div>
      
        <br></br>   

        <Footer />
    </div>
    

);

}

export default Results26;